// Single source of truth for the per-request recipient cap: enforced by the external API
// schema, applied to a selection by capByTestNumber (sibling models file), and surfaced by the
// portal's cap messaging. The portal's dropdown page size is a separate, larger constant
// (TEST_NUMBER_DROPDOWN_PAGE_SIZE) — staff browse more numbers than one request can send.
export const MAX_TEST_MESSAGE_NUMBERS = 50;

export interface IExternalV1TestMessagesCreationRequest {

  // Required Fields
  // Plain numbers stay accepted for backward compatibility (the portal sends number[]);
  // strings allow formatted input like "512-555-0123" or "+1 512 555 0123"
  testNumbers: (string | number)[];

}
